import type { FetchError } from "ofetch";

/**
 * Load slim site/nav once into app.site (useState only).
 * Do not use useAsyncData here: that would duplicate the blob under payload.data.
 */
export default defineNuxtPlugin(async () => {
  const site = useSite();

  if (Array.isArray(site.value?.children) && site.value.children.length > 0) {
    return;
  }

  try {
    site.value = await $fetch<Record<string, unknown>>("/api/site");
  } catch (e) {
    console.error("Error loading site data:", (e as FetchError).message);
  }
});
